export const presetQueries = [
  {
    "query": "What is my total revenue for the month, quarter, and year-to-date?",
    "category": "Revenue & Growth"
  },
  {
    "query": "How does my current revenue compare with the same period last year?",
    "category": "Revenue & Growth"
  },
  {
    "query": "What’s my 12‑month average monthly revenue?",
    "category": "Revenue & Growth"
  },
  {
    "query": "How consistent is my revenue growth over time?",
    "category": "Revenue & Growth"
  },
  {
    "query": "How many consecutive months of revenue growth have I achieved?",
    "category": "Revenue & Growth"
  },
  {
    "query": "How close am I to my next PPL revenue tier?",
    "category": "Revenue & Growth"
  },
  {
    "query": "Is my year‑to‑date revenue tracking ahead or behind my PPL plan?",
    "category": "Revenue & Growth"
  },
  {
    "query": "How does my revenue growth compare with expense growth?",
    "category": "Revenue & Growth"
  },
  {
    "query": "What additional revenue is needed to hit my PPL profit target?",
    "category": "Revenue & Growth"
  },
  {
    "query": "What is my current COGS % of revenue?",
    "category": "COGS & Gross Margin"
  },
  {
    "query": "Has my COGS efficiency improved this quarter?",
    "category": "COGS & Gross Margin"
  },
  {
    "query": "Which COGS category fluctuates the most month‑to‑month?",
    "category": "COGS & Gross Margin"
  },
  {
    "query": "What is my 3‑month average gross margin?",
    "category": "COGS & Gross Margin"
  },
  {
    "query": "What would a 2% COGS reduction add to profit?",
    "category": "COGS & Gross Margin"
  },
  {
    "query": "How many months did I meet my PPL team target?",
    "category": "Team & Labour Efficiency"
  },
  {
    "query": "What’s the profit impact of a 5% payroll increase?",
    "category": "Team & Labour Efficiency"
  },
  {
    "query": "Are contractor costs trending up or down?",
    "category": "Team & Labour Efficiency"
  },
  {
    "query": "Are owner payments increasing faster than profit?",
    "category": "Team & Labour Efficiency"
  },
  {
    "query": "What % of revenue goes to marketing?",
    "category": "Marketing & Business Development"
  },
  {
    "query": "How does marketing trend over the last six months?",
    "category": "Marketing & Business Development"
  },
  {
    "query": "What was my peak marketing month?",
    "category": "Marketing & Business Development"
  },
  {
    "query": "Is my marketing ROI improving relative to revenue growth?",
    "category": "Marketing & Business Development"
  },
  {
    "query": "What % of Business Development spend is recurring versus one‑time?",
    "category": "Marketing & Business Development"
  },
  {
    "query": "What is my average cost to generate $1 of new revenue?",
    "category": "Marketing & Business Development"
  },
  {
    "query": "What % of revenue goes to operations?",
    "category": "Operations & Overheads"
  },
  {
    "query": "Are operations scaling with growth?",
    "category": "Operations & Overheads"
  },
  {
    "query": "What’s my total facilities cost (rent + utilities + maintenance)?",
    "category": "Operations & Overheads"
  },
  {
    "query": "How have software expenses trended this year?",
    "category": "Operations & Overheads"
  },
  {
    "query": "Which overhead categories grew fastest?",
    "category": "Operations & Overheads"
  },
  {
    "query": "What share of overheads are discretionary versus fixed?",
    "category": "Operations & Overheads"
  },
  {
    "query": "How volatile are my overheads?",
    "category": "Operations & Overheads"
  },
  {
    "query": "What’s my total overhead cost per $1 of revenue?",
    "category": "Operations & Overheads"
  },
  {
    "query": "What is my net profit margin?",
    "category": "Profitability & Performance"
  },
  {
    "query": "How stable is profit month‑to‑month?",
    "category": "Profitability & Performance"
  },
  {
    "query": "Which categories drive most profit changes?",
    "category": "Profitability & Performance"
  },
  {
    "query": "How does quarterly profit distribution look?",
    "category": "Profitability & Performance"
  },
  {
    "query": "What’s my average monthly profit in dollars?",
    "category": "Profitability & Performance"
  },
  {
    "query": "How would profit change if I met all PPL cost targets?",
    "category": "Profitability & Performance"
  },
  {
    "query": "How much profit do I earn per $1 of revenue?",
    "category": "Profitability & Performance"
  },
  {
    "query": "What are my top three profit drains this month?",
    "category": "Profitability & Performance"
  },
  {
    "query": "What is my total cash on hand after credit cards?",
    "category": "Cash & Liquidity"
  },
  {
    "query": "How has cash changed since last month?",
    "category": "Cash & Liquidity"
  },
  {
    "query": "What’s the average monthly cash change over the last 3 months?",
    "category": "Cash & Liquidity"
  },
  {
    "query": "How many months of expenses can current cash cover?",
    "category": "Cash & Liquidity"
  },
  {
    "query": "Is cash growth keeping pace with profit growth?",
    "category": "Cash & Liquidity"
  },
  {
    "query": "Which five accounts changed most over the past quarter?",
    "category": "Variance & Diagnostics"
  },
  {
    "query": "Are there uncategorized or miscoded expenses this month?",
    "category": "Variance & Diagnostics"
  },
  {
    "query": "Which cost category shows the strongest downward trend?",
    "category": "Variance & Diagnostics"
  },
  {
    "query": "Which area exceeded its PPL threshold the most?",
    "category": "Variance & Diagnostics"
  },
  {
    "query": "What overall score does my clinic achieve versus Perfect P&L?",
    "category": "Variance & Diagnostics"
  }
];
